import { useState, useEffect, useContext, useMemo } from 'react';
import { isJsonString } from '../../../../utilities/helpers';
import JSONPretty from 'react-json-pretty';
import { ConfigContext } from '../../../../Contexts/ConfigContext';
import { countryCodesList } from '../../../../core/constants';
//mui imports====
import { Box } from '@mui/system';
import useStyles from '../PrebidBiddersConfig/prebidConfigStyle';
import useCommonStyles from '../../../../commonStyles';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import { Grid, Button } from '@mui/material';
//===============

const HbFloorsJson = ({ keyData }) => {
	const classes = useStyles();
	const commonStyleClasses = useCommonStyles();
	const [HbFloorsJsonInput, setHbFloorsJsonInput] = useState('');
	const [HbFloorsJsonCurrent, setHbFloorsJsonCurrent] = useState('');
	const { rawConfig, updateRawConfig } = useContext(ConfigContext);

	// create an object of the existing data from rawConfig state
	const hbFloorsObject = useMemo(() => {
		if (!rawConfig || JSON.stringify(rawConfig) === '{}') return {};
		let newObj = {};
		for (let key in rawConfig) {
			let li = key.lastIndexOf('.');
			if (
				key.includes('networkData.hbFloorsConfig.countryWiseHbFloorMapping') &&
				key !== 'networkData.hbFloorsConfig.countryWiseHbFloorMapping'
			) {
				newObj[key.substring(li + 1)] = rawConfig[key];
			}
		}

		return newObj;
	}, [rawConfig]);

	useEffect(() => {
		setHbFloorsJsonCurrent(hbFloorsObject);
	}, []);

	const handleUpdate = () => {
		if (!isJsonString(HbFloorsJsonInput)) {
			alert('Not a JSON object');
			return;
		}
		const parsedJson = JSON.parse(HbFloorsJsonInput);
		let newRawConfig = { ...rawConfig }; // make a copy of the rawConfig state
		let countryStrings = Object.keys(rawConfig).filter((key) =>
			key.includes('networkData.hbFloorsConfig.countryWiseHbFloorMapping.')
		);
		for (let countryCode of countryCodesList) {
			const key = `networkData.hbFloorsConfig.countryWiseHbFloorMapping.${countryCode}`;
			if (countryStrings.includes(key)) {
				delete newRawConfig[key];
			}
			// if the parsed JSON object has a property with the country code, add it to the newRawConfig object
			if (parsedJson.hasOwnProperty(countryCode)) {
				newRawConfig[key] = parsedJson[countryCode];
			}
		}
		updateRawConfig(newRawConfig); // update the copy of the rawConfig state
	};

	return (
		<Box className={classes.prebidConfig}>
			<Paper style={{ height: 'fit-content', padding: '2rem' }}>
				<Typography className={commonStyleClasses.heading} fontWeight={600} variant="h4">
					HbFloors Json Object
				</Typography>
				<Grid container spacing={2} style={{ marginTop: '1.5rem' }}>
					<Grid item xs={6}>
						<Typography className={commonStyleClasses.heading} fontWeight={600} variant="h4">
							Current
						</Typography>
						<Box className={classes.prebidOutput}>
							<JSONPretty id="json-pretty" data={hbFloorsObject}></JSONPretty>
						</Box>
					</Grid>
					<Grid item xs={6}>
						<Typography className={commonStyleClasses.heading} fontWeight={600} variant="h4">
							Input
						</Typography>
						<TextField
							id="outlined-multiline-static"
							multiline
							value={HbFloorsJsonInput}
							onChange={(e) => setHbFloorsJsonInput(e.target.value)}
							className={classes.textField}
							maxRows={20}
							minRows={20}
						/>
					</Grid>
					<Grid
						item
						xs={12}
						style={{
							display: 'flex',
							justifyContent: 'center'
						}}
					>
						<Button
							variant="contained"
							style={{ marginTop: '2rem', marginBottom: '2rem' }}
							onClick={handleUpdate}
						>
							Update
						</Button>
					</Grid>
				</Grid>
			</Paper>
		</Box>
	);
};
export default HbFloorsJson;
